import React from "react";
import { Form, Input, Button, Spin, Select } from "antd";
import { ReactSVG } from "react-svg";
import { PARTNER_STATUSES } from "../../../constants";

const PartnerForm = ({ form, isFetching, partner, handleSubmit, handleCancel }) => {
  return (
    <Spin spinning={isFetching}>
      <div className="PartnerForm">
        <Form
          form={form}
          scrollToFirstError
          layout="vertical"
          hideRequiredMark
          colon={false}
          onFinish={handleSubmit}
          initialValues={{ status: true }}>
          <div className="FormHeader">
            <div className="left">{partner ? "Edit Partner" : "New Partner"}</div>
          </div>
          <div className="FormContent">
            <Form.Item label="Partner Name" name="name" rules={[{ required: true, message: "Required" }]}>
              <Input size="large" placeholder="Name" />
            </Form.Item>
            <Form.Item label="Status" name="status">
              <Select placeholder="Optional" showSearch optionFilterProp="children">
                {PARTNER_STATUSES?.map(item => (
                  <Select.Option key={item.value} value={item.value}>
                    {item.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              label="Email"
              name="email"
              rules={[
                { type: "email", message: "Invalid Email" },
                { required: true, message: "Required" },
              ]}>
              <Input size="large" placeholder="Email" />
            </Form.Item>
            <Form.Item label="Password" name="password" rules={[{ required: !partner, message: "Required" }]}>
              <Input.Password size="large" placeholder="Password" />
            </Form.Item>
          </div>
          <div className="FormFooter">
            <div className="Left"></div>
            <div className="Right">
              <Button key="cancel" onClick={handleCancel}>
                Cancel
              </Button>
              <Button htmlType="submit" type="primary">
                {partner ? "Update" : "Create"}
                <ReactSVG className="icon" src="/icons/submit.svg" />
              </Button>
            </div>
          </div>
        </Form>
      </div>
    </Spin>
  );
};

export default PartnerForm;
